import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8e9279"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "express-status"
}
const _hoisted_4 = { style: {"width":"370px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-gantanhao cursor-pt" }, null, -1))
const _hoisted_8 = { style: {"width":"320px"} }
const _hoisted_9 = { style: {"max-height":"160px","overflow-y":"auto"} }
const _hoisted_10 = { style: {"color":"#000000E0","font-size":"14px","line-height":"22px","font-weight":"700","margin-bottom":"12px"} }
const _hoisted_11 = { style: {"margin-left":"12px"} }
const _hoisted_12 = { style: {"background":"#E6FFFB","color":"#13C2C2","border-radius":"4px","font-size":"12px","cursor":"pointer"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_15 = {
  class: "flex-ter-cen",
  style: {"color":"#d9001b"}
}

import { getJapanTime } from '@/util/common'
import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { productStatsEnum } from '@/views/usercenter/Order/data'
import { isD2C, useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import { Warning } from '@element-plus/icons-vue'
import dayjs from 'dayjs'
import { getOrderExpressListApi } from '@/apis/order'
// open 打开物流弹窗

export default /*#__PURE__*/_defineComponent({
  props: ['row', 'cancelJump', 'orderNo', 'combineSku', 'showExpress', 'isReplenish'],
  emits: ['open'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()
// cancelJump 取消成功跳转取消商品页面
// showExpress 是否展开查看具体物流信息


const productStatsKeyEnum: any = {
  1: 'waitPurchaeQuantity',
  2: 'purchasingQuantity',
  3: 'hasPurchaeQuantity',
  4: 'expressQuantity',
  5: 'stockInQuantity',
  6: 'checkingQuantity',
  7: 'checkedQuantity',
  8: 'deliveredQuantity',
  9: 'hasDeliverQuantity',
  10: 'confirmQuantity',
  11: 'badClientQuantity',
  // 11: 'badClientQuantity',
  12: 'cancleAndRefundQuantity',
  13: 'keepStockQuantity',
  14: 'onTheWayFreezeQuantity',
  15: 'waitReplenishQuantity'
}

const defectiveAmount = isD2C() ? props.row.badConvertStockQuantity : props.row.defectiveAmount

const setStatus = (status: number) => {
  const statusList = (props.row.orderItemStatus || '').split(',').map((v: string) => Number(v))
  return statusList.includes(status)
}

// TO_BE_PURCHASED(1, "待采购","買付待ち"),
// PURCHASING(2, "采购中","買付対応中"),
// PURCHASED(3, "已采购","買付完了"),
// IN_DOMESTIC_TRANSPORTATION(4, "国内运输中","国内運送中"),
// IN_STOCK(5, "已入库","入庫済み"),
// IN_INSPECTION(6, "检品中","検品中"),
// IT_HAS_BEEN_ADDED_TO(7, "已上架(已清算)","検品済"),
// TO_BE_DELIVERED(8, "待发货","発送待ち"),
// SHIPPED(9, "已发货","発送済"),
// ABNORMAL(10, "异常","異常"),
// DEFECTIVE(11, "次品","不良品"),
// CANCEL_SUCCESS(12, "取消成功","キャンセル済"),
// KEEP_STOCK(13, "保留库存","在庫保管"),
// ON_THE_WAY_STOCK(14, "在途","在途"),
const statusIsFinal = () => {
  const list = [7, 8, 9, 11, 12, 13]
  //  换货需求，上架之后不展示换货中
  const statusList = (props.row.orderItemStatus || '').split(',').map((v: string) => Number(v))
  return statusList.every(v => list.includes(v))
}
const jumpCancelGoods = () => {
  const routerUrl: any = router.resolve(useRtfix('AbnormalOrder', {
    query: {
      abnormal: 'ApplyCancel',
      platformOrderNo2: props.orderNo,
      productSku: props.combineSku || props.row.productSku,
      processManner: '0'
    }
  }))
  window.open(routerUrl.href, '_blank')
}

const toStubstandardList = function (row: any) {
  router.push(
    useRtfix('SubstandardList', {
      query: {
        shopProductSku: row.shopProductSku
      }
    })
  )
}
const visible = ref(false)
const loading = ref(false)
// 查看物流信息
const openExpress = () => {
  console.log(props.row.platformOrderItemId)
  // api
  loading.value = true
  getOrderExpressListApi({
    platformOrderItemId: props.row.platformOrderItemId,
    requestSource: 1
  }).then((res) => {
    emit('open', res.data)
  }).finally(() => {
    loading.value = false
  })
}
// 是否超时
const checkTime = (time: any) => {
  if (!time) return
  time = dayjs(new Date(time)).format('YYYY-MM-DD')
  return new Date(time + ' 23:59:59').getTime() < new Date().getTime()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (__props.row?.orderItemStatus)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        class: "word-break-en"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStatsEnum), (v, k) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (setStatus(Number(k)) && __props.row[productStatsKeyEnum[k]] > 0)
              ? (_openBlock(), _createElementBlock("p", { key: k }, [
                  (__props.cancelJump && Number(k) === 12)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: jumpCancelGoods
                      }, [
                        _createElementVNode("span", null, _toDisplayString(v) + " (" + _toDisplayString(__props.row[productStatsKeyEnum[k]]) + ") ", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        (Number(k) !== 4 || !__props.showExpress || !__props.row.estimateStockTime)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(Number(k)===7 && __props.isReplenish ? _unref(t)('匹配良品') : v) + " (" + _toDisplayString(__props.row[productStatsKeyEnum[k]]) + ") ", 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_el_button, {
                                type: "text",
                                class: "express-status-num",
                                onClick: _withModifiers(openExpress, ["stop"]),
                                loading: loading.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v) + "(" + _toDisplayString(__props.row[productStatsKeyEnum[k]]) + ")", 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "loading"]),
                              (__props.row.estimateStockTime && __props.row.estimateStockTime !== '-')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass([{ warn: checkTime(__props.row.estimateStockTime) }, 'express-status-tip'])
                                  }, [
                                    _createTextVNode(_toDisplayString(__props.row.estimateStockTime) + _toDisplayString(_unref(t)('に到着予定')) + " ", 1),
                                    (checkTime(__props.row.estimateStockTime))
                                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                          key: 0,
                                          effect: "light",
                                          placement: "top",
                                          "popper-class": "express-drawer-tooltip-warn"
                                        }, {
                                          content: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_4, [
                                              _createTextVNode(_toDisplayString(_unref(t)('配達が遅れています。')), 1),
                                              _hoisted_5,
                                              _createTextVNode(" " + _toDisplayString(_unref(t)('現在催促中でしばらくお待ち下さい。')), 1),
                                              _hoisted_6,
                                              _createTextVNode(" " + _toDisplayString(_unref(t)('何かご問題があればカスタマーサービスまでお問い合わせ下さい')), 1)
                                            ])
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_7
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]))
                      ]))
                ]))
              : _createCommentVNode("", true),
            (Number(k) === 2 && !statusIsFinal() && __props.row.changeGoodsRecords?.length && __props.row.changeGoodsRecords!=='-')
              ? (_openBlock(), _createElementBlock("div", {
                  key: '1' + k
                }, [
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "left",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('换货记录')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.row.changeGoodsRecords, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              style: {"line-height":"40px","font-size":"12px"},
                              key: index
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('换货时间')) + "：" + _toDisplayString(_unref(getJapanTime)(item.time)) + " ", 1),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('换货数量')) + ": " + _toDisplayString(item.quantity), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('换货中')) + ">", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256)),
        (_unref(defectiveAmount))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_el_tooltip, {
                placement: "left",
                effect: "light",
                "popper-class": "tips"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref(t)('次品经您转为正品后，可视为正品下单，存在消费者不可接受的风险，请谨慎操作！平台不承担相关责任。')) + " ", 1),
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (toStubstandardList(__props.row)))
                    }, _toDisplayString(_unref(t)('查看转正记录>')), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Warning))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(`${_unref(t)('含次品转正品')}(${_unref(defectiveAmount)})`), 1)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})